(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fc-collection-banner"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var banners = document.querySelectorAll('.fc-collection-banner');

    banners.forEach(function (banner) {
      var button = banner.querySelector('.fc-collection-banner__button.scroll-trigger');
      if (!button) return;

      button.addEventListener('click', function () {
        var scrollTarget = banner.dataset.scrollTarget;
        var targetElement;

        if (scrollTarget) {
          targetElement = document.querySelector(scrollTarget);
        }

        if (!targetElement) {
          var section = banner.closest('.shopify-section');
          if (section && section.nextElementSibling) {
            targetElement = section.nextElementSibling;
          }
        }

        if (targetElement) {
          targetElement.scrollIntoView({ behavior: 'smooth' });
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fc-instagram"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('fc-instagram-videos')) {
  customElements.define(
    'fc-instagram-videos',
    class FcInstagramVideos extends HTMLElement {
      connectedCallback() {
        this.slider = this.querySelector('.swiper');
        if (!this.slider) return;

        this.slideCount = parseInt(this.dataset.slideCount, 10) || 0;
        this.isMobile = window.matchMedia('(max-width: 767px)').matches;

        this.waitForCarousel();

        this.mediaQuery = window.matchMedia('(max-width: 767px)');
        this.mediaQuery.addEventListener('change', (e) => {
          this.isMobile = e.matches;
          this.destroySlider();
          this.initSlider();
        });
      }

      waitForCarousel() {
        if (window.FoxTheme && window.FoxTheme.Carousel) {
          this.initSlider();
        } else {
          const check = setInterval(() => {
            if (window.FoxTheme && window.FoxTheme.Carousel) {
              clearInterval(check);
              this.initSlider();
            }
          }, 100);
        }
      }

      initSlider() {
        const options = {
          slidesPerView: 'auto',
          spaceBetween: this.isMobile ? -8 : -21,
          centeredSlides: true,
          loop: this.slideCount > 2,
          slideToClickedSlide: true,
          grabCursor: true,
          speed: 400,
        };

        this.swiperInstance = new window.FoxTheme.Carousel(this.slider, options);
        this.swiperInstance.init();
        this.swiper = this.swiperInstance.slider || this.swiperInstance;

        this.playActiveVideo();

        this.swiper.on('slideChangeTransitionEnd', () => {
          this.playActiveVideo();
        });
      }

      destroySlider() {
        this.pauseAllVideos();
        if (this.swiper && this.swiper.destroy) {
          this.swiper.destroy(true, true);
        }
        this.swiper = null;
        this.swiperInstance = null;
      }

      playActiveVideo() {
        this.pauseAllVideos();
        const activeSlide = this.querySelector('.swiper-slide-active');
        if (!activeSlide) return;

        activeSlide.classList.add('fc-instagram__slide--playing');
        const video = activeSlide.querySelector('.fc-instagram__video');
        if (video) video.play();
      }

      pauseAllVideos() {
        this.querySelectorAll('.fc-instagram__slide').forEach((slide) => {
          slide.classList.remove('fc-instagram__slide--playing');
          const video = slide.querySelector('.fc-instagram__video');
          if (video) {
            video.pause();
            video.currentTime = 0;
          }
        });
      }
    }
  );
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fc-reviews"] && !Shopify.designMode) return;
  try {
    
(function () {
  var swiperInstances = [];
  var mql = window.matchMedia('(max-width: 767px)');

  function initDesktop() {
    document.querySelectorAll('fc-reviews').forEach(function (list) {
      if (list.dataset.fcInit) return;
      list.dataset.fcInit = 'true';

      var step = parseInt(list.dataset.step, 10) || 3;
      var btn = list.querySelector('.fc-reviews__load-more');
      if (!btn) return;

      btn.addEventListener('click', function () {
        if (btn.classList.contains('fc-reviews__load-more--loading')) return;

        btn.classList.add('fc-reviews__load-more--loading');
        var hidden = Array.prototype.slice.call(list.querySelectorAll('.fc-reviews__card--hidden'), 0, step);

        setTimeout(function () {
          hidden.forEach(function (card, i) {
            setTimeout(function () {
              card.classList.remove('fc-reviews__card--hidden');
              card.classList.add('fc-reviews__card--revealing');
              card.addEventListener('animationend', function handler() {
                card.classList.remove('fc-reviews__card--revealing');
                card.removeEventListener('animationend', handler);
              });
            }, i * 80);
          });

          setTimeout(function () {
            btn.classList.remove('fc-reviews__load-more--loading');
            if (list.querySelectorAll('.fc-reviews__card--hidden').length === 0) {
              btn.closest('.fc-reviews__load-more-wrap').style.display = 'none';
            }
          }, hidden.length * 80 + 400);
        }, 400);
      });
    });
  }

  function initSliders() {
    document.querySelectorAll('.fc-reviews__swiper').forEach(function (slider) {
      /* Skip if slider container has no width — Swiper can't calculate dimensions */
      if (slider.offsetWidth === 0) return;

      var container = slider.closest('.fc-reviews__container');
      if (!container) return;

      var carousel = new window.FoxTheme.Carousel(slider, {
        slidesPerView: 1,
        spaceBetween: 16,
        grabCursor: true,
        observer: true,
        observeParents: true,
        navigation: {
          prevEl: container.querySelector('.fc-reviews__arrow--prev'),
          nextEl: container.querySelector('.fc-reviews__arrow--next'),
        },
        pagination: {
          el: container.querySelector('.fc-reviews__dots'),
          clickable: true,
          type: 'bullets',
        },
      });
      carousel.init();
      swiperInstances.push(carousel);
    });
  }

  function destroySliders() {
    swiperInstances.forEach(function (carousel) {
      if (carousel && carousel.slider && carousel.slider.destroy) {
        carousel.slider.destroy(true, true);
      }
    });
    swiperInstances = [];
  }

  function handleViewport(e) {
    if (e.matches) {
      requestAnimationFrame(function () {
        initSliders();
      });
    } else {
      destroySliders();
    }
  }

  function initFcReviews() {
    initDesktop();
    if (mql.matches) {
      /* Defer slider init to next frame so the browser has painted
         the container and Swiper can read its actual width */
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          initSliders();
        });
      });
    }
    mql.addEventListener('change', handleViewport);
  }

  function waitForCarousel() {
    if (window.FoxTheme && window.FoxTheme.Carousel) {
      initFcReviews();
    } else {
      document.addEventListener('DOMContentLoaded', function () {
        var check = setInterval(function () {
          if (window.FoxTheme && window.FoxTheme.Carousel) {
            clearInterval(check);
            initFcReviews();
          }
        }, 100);
      });
    }
  }

  waitForCarousel();
})();

  } catch(e) { console.error(e); }
})();
})();
